import { apiClient } from '../../lib/api-client';
import type {
  ApiSuccess,
  PaginatedWorklistResponse,
  PathologyAction,
  PathologyListFilters,
  PathologyReportBundle,
  UpdatePathologyReportsPayload,
  WorklistFilters,
} from './types';

const compactParams = (params: object) => Object.fromEntries(
  Object.entries(params).filter(([, value]) => value !== '' && value !== undefined && value !== null),
);

export const fetchPathologyWorklist = async (filters: PathologyListFilters) => {
  const response = await apiClient.get<PaginatedWorklistResponse>('/investigation-bill/pathology', { params: compactParams(filters) });
  return response.data;
};

export const fetchNonPathologyWorklist = async (filters: WorklistFilters) => {
  const response = await apiClient.get<PaginatedWorklistResponse>('/investigation-bill/non-pathology', { params: compactParams(filters) });
  return response.data;
};

export const fetchRadiologyWorklist = async (filters: WorklistFilters) => {
  const response = await apiClient.get<PaginatedWorklistResponse>('/investigation-bill/radiology', { params: compactParams(filters) });
  return response.data;
};

export const fetchReadyReportWorklist = async (filters: WorklistFilters) => {
  const response = await apiClient.get<PaginatedWorklistResponse>('/investigation-bill/ready-report', { params: compactParams(filters) });
  return response.data;
};

export const advancePathologyStatus = async (billId: string, lineIds: string[], action: PathologyAction) => {
  const response = await apiClient.patch<ApiSuccess<{ updated: number }>>(`/investigation-bill/pathology/${billId}`, { lineIds, action });
  return response.data.data;
};

export const fetchPathologyReports = async (billId: string, lineIds: string[]) => {
  const response = await apiClient.get<ApiSuccess<PathologyReportBundle>>(`/investigation-bill/pathology/reports/${billId}`, { params: compactParams({ lineIds: lineIds.join(',') }) });
  return response.data.data;
};

export const updatePathologyReports = async (billId: string, payload: UpdatePathologyReportsPayload) => {
  const response = await apiClient.patch<ApiSuccess<PathologyReportBundle>>(`/investigation-bill/pathology/reports/${billId}`, payload);
  return response.data.data;
};
